import React from 'react';
import styled from 'styled-components';

import DurationBlockNew from '../DurationBlockNew/DurationBlockNew';

import RatingStarIcon from '../../../../Icons/RatingStarIcon';
import LocationIcon from '../../../../Icons/LocationIcon';

type HotelDetailsWrapType = {
  hn: string;
  address: string;
  hotelStars: number;
  rating: string | number;
};
const HotelDetailsWrap: React.FC<HotelDetailsWrapType> = ({
  hn,
  address,
  hotelStars = 0,
  rating,
}) => (
  <HotelDetailsWrapOuterDiv>
    <HotelDetailsOuterDiv>
      <HotelDetailsInnerWrapDiv>
        <ReviewHotelNameDiv>
          <ReviewHotelNamePara>
            <span>{hn}</span> 
            {(!!hotelStars && (
              <StarRatingDiv>
                {Array(hotelStars)
                  .fill(1)
                  .map((i, index) => (
                    <StarDiv key={`${index}star`} />
                  ))}
              </StarRatingDiv>
            )) ||
            null}
          </ReviewHotelNamePara>
        </ReviewHotelNameDiv>

        <ReviewHotelNameDiv>
          {/* <AddressSpan>{address} &nbsp; | <span className="distText">1.2km</span> <span className="boldText">from Tito's Lane</span></AddressSpan> */}
          <AddressSpan>{address}</AddressSpan>
        </ReviewHotelNameDiv>
      
      </HotelDetailsInnerWrapDiv>

      <HotelDetailWrapReviewDiv>
        {!!rating && (
          <ReviewPointWrapDiv>
            <ReviewPointTextSpan>{rating}/5</ReviewPointTextSpan>
          </ReviewPointWrapDiv>
        )}
      </HotelDetailWrapReviewDiv>
    </HotelDetailsOuterDiv>
    {/* <HotelTypeTagDiv>
      <HotelTypeTagInner>Local ID's Accepted</HotelTypeTagInner>
    </HotelTypeTagDiv> */}
    <DurationBlockNew></DurationBlockNew>

  </HotelDetailsWrapOuterDiv>
);

export default HotelDetailsWrap;

const HotelDetailsWrapOuterDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    padding-left:${props.theme.spacing.large.l20};
    width: 60rem;
    justify-content: space-between;
  `
);

const HotelDetailsOuterDiv = styled.div(
  props => `
    width:100%;
    display: flex;
    justify-content: space-between;
  `
)

export const HotelDetailsInnerWrapDiv = styled.div(
  props => `
    width:80%;
    display: flex;
    flex-direction: column;

  `
);

export const HotelDetailWrapReviewDiv = styled.div(
  props => `
    width:20%;
    display: flex;
    align-self: flex-start;
    justify-content: flex-end;
  `
)

const StarDiv = styled(RatingStarIcon)(
  props => `
    width: 1.1rem;
    height: 1.1rem;
    margin-right:${props.theme.spacing.small.s2};
    color: ${props.theme.colors.black.base};
  `
);

const StarRatingDiv = styled.span(
  props => `
    padding-left: ${props.theme.spacing.base};
  `
);

const ReviewHotelNameDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: nowrap;
    flex-direction: row;
  `
);

const ReviewHotelNamePara = styled.p(
  props => `
    font-size:${props.theme.font.large.font22};
    font-weight:${props.theme.font.fontWeight.black};
    color: ${props.theme.colors.black.base};
    vertical-align: middle;
  `
);

const LocationDiv = styled(LocationIcon)(
  props => `
    width:1.8rem;
    height:1.8rem;
    margin-right:${props.theme.spacing.small.s5};
    fill:#898b91;
  `
);

const AddressSpan = styled.span(
  props => `
    display:flex;
    font-size:${props.theme.font.base};
    color:${props.theme.colors.grey.base};
    padding-top:${props.theme.spacing.small.s2};

    .distText{
      color: ${props.theme.colors.green.base};
      font-weight: ${props.theme.font.fontWeight.bold};
      padding-left:${props.theme.spacing.small.s4};
    }
    .boldText{
      color: ${props.theme.colors.grey.base};
      font-weight: ${props.theme.font.fontWeight.bold};
      padding-left:${props.theme.spacing.small.s2};
    }
  `
);

const ReviewByUserDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    padding-top:${props.theme.spacing.small.s5};
  `
);

const ReviewPointWrapDiv = styled.div(
  props => `
    display: flex;
    flex-wrap:wrap;
    flex-direction: column;
    padding-top:${props.theme.spacing.small.s2};
    padding-bottom:${props.theme.spacing.small.s2};
    padding-right:${props.theme.spacing.small.s5};
    padding-left:${props.theme.spacing.small.s5};
    align-self:flex-start;
    background:${props.theme.colors.green.base};
    border-radius: ${props.theme.misc.borderRadius.small};
    justify-content: flex-end;
  `
);

const ReviewPointTextSpan = styled.span(
  props => `
    display:flex;
    font-size:${props.theme.font.base};
    color:${props.theme.colors.white.base};
    font-weight:bold;
  `
);

const HotelTypeTagDiv = styled.div(
  props => `
    width:100%;
    display: flex;
  `
);

const HotelTypeTagInner = styled.p(
  props => `
    align-self: flex-start;
    display: flex;
    border-radius: ${props.theme.misc.borderRadius.base};
    border: solid 1px ${props.theme.colors.grey.lighte7};
    background-color: ${props.theme.colors.grey.lightf2};
    padding: ${props.theme.spacing.small.s4} ${props.theme.spacing.small.s8};
    font-size: ${props.theme.font.small.sfont11};
    color: ${props.theme.colors.grey.base};
  `
)
